const getItemPositioning = (defaultPosition, position) => {
  const options = [
    "top-left",
    "top-center",
    "top-right",
    "bottom-left",
    "bottom-center",
    "bottom-right",
    "right",
    "left",
    "center"
  ];
  if (position && options.includes(position)) {
    return position;
  } else {
    console.error(`The position ${position} is not a valid option`);
  }
  return defaultPosition;
};
const getScreenMaxWidth = () => {
  return "calc(100vw - (100vw - 100%) - env(safe-area-inset-left) - env(safe-area-inset-right))";
};
const getScreenMaxHeight = () => {
  return "calc(100vh - env(safe-area-inset-top) - env(safe-area-inset-bottom))";
};

export { getItemPositioning, getScreenMaxHeight, getScreenMaxWidth };
//# sourceMappingURL=bundle.esm3.js.map
